export const HIDE_MESSAGE = '[MESSAGE] CLOSE';
export const SHOW_MESSAGE = '[MESSAGE] SHOW';

export function hideMessage() {
	return {
		type: HIDE_MESSAGE
	};
}

export function showMessage(options) {
	return {
		type: SHOW_MESSAGE,
		options
	};
}

export const showToast = {
	error: message => ({ type: SHOW_MESSAGE, options: { message, variant: 'error' } }),
	success: message => ({ type: SHOW_MESSAGE, options: { message, variant: 'success' } }),
	info: message => ({ type: SHOW_MESSAGE, options: { message, variant: 'info' } }),
	warning: message => ({ type: SHOW_MESSAGE, options: { message, variant: 'warning' } })
};
